<template>
    <v-progress-circular :size="size" :width="width" :value="porcentaje" :rotate="rotate" :color="color">
        {{ porcent }}%
    </v-progress-circular>
</template>

<script>
    export default {
        name: "PresupProgreso",
        props: ['size', 'width', 'porcentaje', 'rotate'],
        computed: {
            porcent() {
                return new Intl.NumberFormat('es-AR', {minimumFractionDigits: 0, maximumFractionDigits: 0}).format(this.porcentaje);
            },
            color() {
                let hue = (this.porcentaje *120).toString(10);
                return ["hsl(", hue, ",100%,40%)"].join("");
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/PresupProgreso.vue